export function withPrefix(path: string) {
  return path;
}

export namespace PageURLs {
  export function ofIndex() {
    return withPrefix('/');
  }

  // users
  export function ofUsersManagement() {
    return withPrefix('/users/management');
  }
  export function ofUsersActivity() {
    return withPrefix('/users/activity-log');
  }

  // home
  export function ofHomeBannerSlider() {
    return withPrefix('/home/banner-slider');
  }
  export function ofHomeAboutUs() {
    return withPrefix('/home/about-us');
  }
  export function ofHomeBannerHeader() {
    return withPrefix('/home/banner-header');
  }

  // permissions
  export function ofAdminManagement() {
    return withPrefix('/permissions/admin-management');
  }
  export function ofRoleManagement() {
    return withPrefix('/permissions/role-management');
  }
  export function ofAdminActivityLog() {
    return withPrefix('/permissions/admin-activity-log');
  }

  // health
  export function ofUnitConversion() {
    return withPrefix('/health/unit-conversion');
  }
  export function ofConclusionRecommendation() {
    return withPrefix('/health/conclusion-recommendation');
  }

  //health-consulting-management
  export function ofHealthConsultingManagement() {
    return withPrefix('/wellnessCare/manage-physical-activity');
  }

  //food-management
  export function ofFoodManagement() {
    return withPrefix('/wellnessCare/food-management');
  }

  //dish-management
  export function ofDishManagement() {
    return withPrefix('/wellnessCare/dish-management');
  }

  //nutrition-standards-management
  export function ofNutritionStandardsManagement() {
    return withPrefix('/wellnessCare/nutrition-standards-management');
  }

  //product-management
  export function ofProductManagement() {
    return withPrefix('/wellnessCare/product-management');
  }

  // Health status management
  export function ofHealthStatusManagement() {
    return withPrefix('/wellnessCare/health-status-management');
  }

  // Advice recommendation management
  export function ofAdviceRecommendationManagement() {
    return withPrefix('/wellnessCare/advice-recommendation-management');
  }

  //food-management
  export function ofComboFoodManagement() {
    return withPrefix('/wellnessCare/combo-food-management');
  }

  export function ofNutritionalMenuCalculatorManagement() {
    return withPrefix('/wellnessCare/nutritional-menu-calculator-management');
  }

  export function ofNotificationManagement() {
    return withPrefix('/notification-management');
  }

  // chatGPT
  export function ofChatGPT() {
    return withPrefix('/gpt/chatGPT-management');
  }

  export function ofHistoryChatBox() {
    return withPrefix('/gpt/history-chat-box');
  }

  export function ofUploadKeyAndConfig() {
    return withPrefix('/gpt/upload-key-and-config');
  }

  // login
  export function ofLogin() {
    return withPrefix('/login');
  }

  // not found
  export function of404() {
    return withPrefix('/404');
  }

  // Unauthorize
  export function of403() {
    return withPrefix('/403');
  }
}
